import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, SaveExpensaConfiguration1RequestDto, SaveExpensaConfiguration2RequestDto, SaveExpensaConfiguration3RequestDto,SaveExpensaDto,SaveExpensaLiquidacionResponseDto, SaveExpensaMovimientoDeudaDto, SaveGastosPeriodoRequestDto } from "../model/index";
import { ExpensaUnidadFuncionalGastosPorcentajeRequestDto, ExpensaUnidadFuncionalGastosPorcentajeResponseDto, SaveExpensaLiquidacionRequestDto, ExpensaLiquidacionResumenDto } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class ExpensaService extends CrudService<any, number, any, any> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'expensa', sharedFunctions);

  }

  getResumenLiquidacion(id: number): Observable<GenericResponse<ExpensaLiquidacionResumenDto>> {
    return this._http.get<GenericResponse<ExpensaLiquidacionResumenDto>>(this._serviceUrl+'/resumen-liquidacion/'+id, this.httpOptions);
  }

  getUnidadFuncionalGastoPorcentajes(p: ExpensaUnidadFuncionalGastosPorcentajeRequestDto): Observable<GenericResponse<ExpensaUnidadFuncionalGastosPorcentajeResponseDto>> {
    var queryString = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericResponse<ExpensaUnidadFuncionalGastosPorcentajeResponseDto>>(this._serviceUrl+'/uf-gasto-porcentajes'+queryString, this.httpOptions);
  }

  saveConfig1(p: SaveExpensaConfiguration1RequestDto): Observable<GenericResponse<any>> {
    return this._http.post<GenericResponse<any>>(this._serviceUrl + '/configuration/save-1', p, this.httpOptions);
  }

  saveConfig2(p: SaveExpensaConfiguration2RequestDto): Observable<GenericResponse<any>> {
    return this._http.post<GenericResponse<any>>(this._serviceUrl + '/configuration/save-2', p, this.httpOptions);
  }

  saveConfig3(p: SaveExpensaConfiguration3RequestDto): Observable<GenericResponse<any>> {
    return this._http.post<GenericResponse<any>>(this._serviceUrl + '/configuration/save-3', p, this.httpOptions);
  }

  saveLiquidacion(p: SaveExpensaLiquidacionRequestDto): Observable<GenericResponse<SaveExpensaLiquidacionResponseDto>> {
    return this._http.post<GenericResponse<SaveExpensaLiquidacionResponseDto>>(this._serviceUrl + '/save-liquidacion', p, this.httpOptions);
  }

  simulateLiquidacion(p: SaveExpensaLiquidacionRequestDto): Observable<GenericResponse<SaveExpensaLiquidacionResponseDto>> {
    return this._http.post<GenericResponse<SaveExpensaLiquidacionResponseDto>>(this._serviceUrl + '/simulate-liquidacion', p, this.httpOptions);
  }

  createLiquidacionDocument(id: number): Observable<any> {
    return this._http.get<any>(this._serviceUrl + '/create-liquidacion-doc/'+id, this.httpPdfOptions);
  }

  sendLiquidacionDocument(id: number): Observable<GenericResponse<any>> {
    return this._http.get<GenericResponse<any>>(this._serviceUrl + '/send-liquidacion-doc/'+id, this.httpOptions);
  }

  saveGastosPeriodo(p: SaveGastosPeriodoRequestDto): Observable<GenericResponse<any>> {
    return this._http.post<GenericResponse<any>>(this._serviceUrl + '/save-gastos-periodo', p, this.httpOptions);
  }

  getDashboardMisExpensasUrl(): string {
    return this._serviceUrl + '/dashboard-mis-expensas';
  }

  getDashboardMisExpensas(id: number): Observable<GenericResponse<ExpensaLiquidacionResumenDto>> {
    return this._http.get<GenericResponse<ExpensaLiquidacionResumenDto>>(this.getDashboardMisExpensasUrl(), this.httpOptions);
  }

  crearMovimiento(p: SaveExpensaMovimientoDeudaDto): Observable<GenericResponse<any>> {
    return this._http.post<GenericResponse<any>>(this._serviceUrl + '/crear-movimiento/'+p.Id, p, this.httpOptions);
  }

  borrador(id: number): Observable<GenericResponse<any>> {
    return this._http.post<GenericResponse<any>>(this._serviceUrl + '/draft', { Id: id }, this.httpOptions);
  }

  publicar(id: number): Observable<GenericResponse<any>> {
    return this._http.post<GenericResponse<any>>(this._serviceUrl + '/publish', { Id: id }, this.httpOptions);
  }
}